import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Row,
  Input,
  InputGroup,
  Button,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage, useIntl } from "react-intl";
import { AddWorkStepComponents } from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export default function AddNewWorkStepComponentModal({
  isOpen,
  toggle,
  level,
  objId,
  workStepId,
  periodId,
}) {
  const intl = useIntl();
  const [newWorkStepComponentName, setNewWorkStepComponentName] = useState("");
  const queryClient = useQueryClient();
  const postNewWorkStepComponents = useMutation({ mutationFn: AddWorkStepComponents });

  const handleCloseModal = () => {
    setNewWorkStepComponentName("");
    toggle();
  };

  const handlePost = () => {
    let workStepComponentResource = {
      WorkStepId: workStepId,
      WorkStepComponents: [{ name: newWorkStepComponentName }],
    };
    postNewWorkStepComponents.mutate(workStepComponentResource, {
      throwOnError: true,
      onSuccess: () => {
        toast.success("postning lyckad");
        handleCloseModal();
        queryClient.invalidateQueries({ queryKey: ["FetchWorkCardHours", [level, periodId, objId]] });
      },
      onError: (data) => {
        toast.warn(data.response.data);
      },
    });
  };

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle}>
      <ModalHeader>
        <FormattedMessage id="AddWorkStepComponent" />
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col lg={9}>
            <span className="text-warning">
              <FontAwesomeIcon
                icon="triangle-exclamation"
                style={{ marginRight: "0.1rem" }}
              />
            </span>
            <span className="font-italic">
              <FormattedMessage id="ConsiderThatTheWorkcardChangesForEveryone" />
              .
            </span>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col lg={6}>
            <InputGroup>
              <Input
                type="text"
                placeholder={intl.formatMessage({ id: "SubStepName" })}
                onChange={(data) => {
                  setNewWorkStepComponentName(data.target.value);
                }}
              />
            </InputGroup>
          </Col>
        </Row>
        <ModalFooter className="mt-2">
          <Button outline color="secondary" onClick={() => handleCloseModal()}>
            <FormattedMessage id="Cancel" />
          </Button>
          <Button outline color="primary" onClick={() => handlePost()}>
            <FormattedMessage id="Save" />
          </Button>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
}
